import { createApi } from '../client'

const api = createApi('/permissions')

export default api
